import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  selectAll,
  selectEntities,
  selectIds,
  State,
} from './lib/location/location.reducer';

export * from './lib/location-api/location-api.actions';
export * from './lib/location-ws/location-ws.actions';
export * from './lib/location/location.actions';
export * from './lib/location/location.model';
export * from './lib/shared-location-data-access.module';
export * from './lib/location-status/location-status.service';

export const getState = createFeatureSelector<State>('location');

export const getLocations = createSelector(getState, selectAll);

export const getLocationEntities = createSelector(getState, selectEntities);

export const getLocationIds = createSelector(getState, selectIds);


